module.exports = __webpack_public_path__ + "img/motorcheck-logo.7e93f8c9.png";